import React from 'react';
import Icon from '../../../components/AppIcon';

const PredictionSection = ({ title, icon, children, isOpen, onToggle, points, required, hasError, sectionId }) => {
  return (
    <div id={sectionId} className={`bg-card rounded-lg shadow-elevation-sm mb-4 overflow-visible ${hasError ? 'ring-1 ring-destructive' : ''}`}>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 md:p-6 hover:bg-muted/50 transition-colors duration-250 lg:cursor-default"
        aria-expanded={isOpen}
      >
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center ${hasError ? 'bg-destructive/10' : 'bg-primary/10'}`}>
            <Icon name={icon} size={20} className={hasError ? 'text-destructive' : 'text-primary'} />
          </div>
          <div className="text-left">
            <h3 className="text-base md:text-lg font-semibold text-foreground">
              {title}
              {required && <span className="text-destructive ml-1">*</span>}
            </h3>
            {points && (
              <p className="text-xs md:text-sm text-muted-foreground">
                Base Points: <span className="font-semibold text-primary">{points}</span>
              </p>
            )}
          </div>
        </div>
        <Icon 
          name={isOpen ? "ChevronUp" : "ChevronDown"} 
          size={20} 
          className="text-muted-foreground lg:hidden"
        />
      </button>
      
      <div className={`${isOpen ? 'block' : 'hidden'} lg:block p-4 md:p-6 pt-0 lg:pt-0 overflow-visible`}>
        {children}
      </div>
    </div>
  );
};

export default PredictionSection;